const PrivacyPolicyPublic = () => {
    return (
      <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg mt-10">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">Privacy Policy</h1>
        {/* <p className="text-gray-600 text-center">Effective Date: [Insert Date]</p> */}
  
        <p className="mt-4 text-gray-700">
          At <strong>iWash</strong>, we value your privacy and are committed to safeguarding your personal information. This Privacy Policy explains how we collect, use, store, and protect your data when you use our laundry services.
        </p>
  
        {/* Section 1 - Information We Collect */}
        <h2 className="text-2xl font-semibold mt-6 text-gray-800">1. Information We Collect</h2>
        <p className="text-gray-700 mt-2">
          When you use our app, we may collect different types of information, including:
        </p>
        <ul className="list-disc ml-6 mt-2 text-gray-700">
          <li><strong>Personal Details:</strong> Name, phone number, email address, delivery address, and payment details.</li>
          {/* <li><strong>Usage Data:</strong> Browsing activity, device information, app interactions, and location data (if enabled).</li> */}
          <li><strong>Service Preferences:</strong> Your selected laundry services (e.g., washing, ironing, dry cleaning) and delivery options.</li>
        </ul>
  
        {/* Section 2 - How We Use Your Information */}
        <h2 className="text-2xl font-semibold mt-6 text-gray-800">2. How We Use Your Information</h2>
        <p className="text-gray-700 mt-2">
          We use the data collected for the following purposes:
        </p>
        <ul className="list-disc ml-6 mt-2 text-gray-700">
          <li>To provide and enhance our laundry services.</li>
          <li>To process orders, schedule collections, and ensure timely deliveries.</li>
          <li>To send order confirmations, invoices, and promotional offers (if opted in).</li>
          <li>To personalize your app experience and provide relevant service recommendations.</li>
          <li>To improve app performance and address technical issues.</li>
        </ul>
  
        {/* Section 3 - Sharing Your Information */}
        <h2 className="text-2xl font-semibold mt-6 text-gray-800">3. Sharing Your Information</h2>
        <p className="text-gray-700 mt-2">
          We do not sell your personal information. However, we may share your data with:
        </p>
        <ul className="list-disc ml-6 mt-2 text-gray-700">
          <li><strong>Service Providers:</strong> To facilitate payments, deliveries, and app functionality.</li>
          <li><strong>Legal Compliance:</strong> If required by law, court orders, or government regulations.</li>
        </ul>
  
        {/* Section 4 - Data Security */}
        <h2 className="text-2xl font-semibold mt-6 text-gray-800">4. Data Security</h2>
        <p className="text-gray-700 mt-2">
          We implement strong security measures to protect your personal data from unauthorized access, disclosure, or misuse. However, please note that no internet-based system is completely secure, and we encourage you to protect your account credentials.
        </p>
  
        {/* Section 5 - Your Rights */}
        <h2 className="text-2xl font-semibold mt-6 text-gray-800">5. Your Rights</h2>
        <p className="text-gray-700 mt-2">As a user, you have the right to:</p>
        <ul className="list-disc ml-6 mt-2 text-gray-700">
          <li>Access and update your personal information.</li>
          <li>Request data deletion (subject to legal obligations).</li>
          <li>Opt-out of promotional emails by updating preferences in the app.</li>
        </ul>
  
        {/* Section 6 - Cookies */}
        <h2 className="text-2xl font-semibold mt-6 text-gray-800">6. Cookies</h2>
        <p className="text-gray-700 mt-2">
          We use cookies to enhance your app experience, store preferences, and improve functionality. You can disable cookies through your device settings if preferred.
        </p>
  
        {/* Section 7 - Policy Updates */}
        <h2 className="text-2xl font-semibold mt-6 text-gray-800">7. Changes to This Policy</h2>
        <p className="text-gray-700 mt-2">
          We may update this Privacy Policy from time to time. We will notify you of any significant changes through the app or email.
        </p>
  
        {/* Section 8 - Contact Us */}
        <h2 className="text-2xl font-semibold mt-6 text-gray-800">8. Contact Us</h2>
        <p className="text-gray-700 mt-2">
          If you have any questions or concerns about our Privacy Policy, please contact us at:
        </p>
        <div className="mt-4 bg-gray-100 p-4 rounded-lg">
          <p><strong>Company Name:</strong> iWash</p>
          <p><strong>Email:</strong> support@iwash.com</p>
          {/* <p><strong>Phone:</strong> +1 (123) 456-7890</p> */}
          {/* <p><strong>Address:</strong> 123 Laundry St, Clean City, USA</p> */}
        </div>
      </div>
    );
  };
  
  export default PrivacyPolicyPublic;
  